module.exports = __webpack_public_path__ + "static/media/mazaZoleWon_50000.2cad7f3d.png";